import { Link } from 'react-router-dom';

import { Card, CardContent } from '@/components/ui/card';
import { PieceIcon } from '@/features/pieces/components/piece-icon';
import { PieceMetadataModelSummary } from '@activepieces/pieces-framework';

import { pieceStepCountsLabel } from '../lib/catalog-labels';
import { CatalogLinkState } from '../lib/catalog-navigation';

import { PieceBusinessBadge } from './piece-business-badge';

type PieceCatalogCardProps = {
  piece: PieceMetadataModelSummary;
  to: string;
  linkState: CatalogLinkState;
};

export const PieceCatalogCard = ({
  piece,
  to,
  linkState,
}: PieceCatalogCardProps) => (
  <Link to={to} state={linkState} className="block h-full">
    <Card className="h-full transition-colors hover:bg-accent/50">
      <CardContent className="flex h-full flex-col gap-3 p-4">
        <div className="flex items-center gap-3">
          <PieceIcon
            logoUrl={piece.logoUrl}
            displayName={piece.displayName}
            size="md"
            border
            showTooltip={false}
          />
          <span className="min-w-0 flex-1 truncate font-medium">
            {piece.displayName}
          </span>
          <PieceBusinessBadge pieceName={piece.name} />
        </div>
        <p className="line-clamp-2 text-sm text-muted-foreground">
          {piece.description}
        </p>
        <p className="mt-auto text-xs text-muted-foreground">
          {pieceStepCountsLabel(piece.triggers, piece.actions)}
        </p>
      </CardContent>
    </Card>
  </Link>
);
